module.exports = __webpack_public_path__ + "img/gbz.188351b9.png";